import { render, staticRenderFns } from "./ServiceConsume.vue?vue&type=template&id=37e86636"
import script from "./ServiceConsume.vue?vue&type=script&lang=js"
export * from "./ServiceConsume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports